import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import navigation from '../navigation';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

class Blog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "Блог",
            text: "Инфо",
            dateValueFrom: "",
            dateValueTo: "",
            languageValue: "",
            destination: ""
        }
    }

    handleDateFromChange = (event, date) => this.setState({
        dateValueFrom: date
    });
    handleDateToChange = (event, date) => this.setState({
        dateValueTo: date
    });


    handleLanguageChange = (event, index, value) => this.setState({
        languageValue: value
    });

    handleDestinationChange = (event, index, value) => this.setState({
        destination: value
    });

    readDestinations = (excludeDestinations) => {
        return Session.model.destinationPages.filter(dest => excludeDestinations.indexOf(dest.name) != -1);
    }

    readBlogs = () => {
        let filteredBlogs = i.Utils.sortByDate(Session.model.blogPages, true);
        let lang = Session.model.home.lang;

        if (filteredBlogs && filteredBlogs.length > 0) {
            filteredBlogs = filteredBlogs.filter(f => f.lang == lang)
        }

        if (this.state.destination && this.state.destination != EMPTY_FILTER_VALUE) {
            filteredBlogs = filteredBlogs.filter(f => f.destination == this.state.destination);
        }

        if (this.state.dateValueFrom && this.state.dateValueFrom != EMPTY_FILTER_VALUE) {
            filteredBlogs = filteredBlogs.filter(f => (new Date(f.date)) >= this.state.dateValueFrom);
        }

        if (this.state.dateValueTo && this.state.dateValueTo != EMPTY_FILTER_VALUE) {
            filteredBlogs = filteredBlogs.filter(f => (new Date(f.date)) <= this.state.dateValueTo);
        }

        let displayedBlogs = filteredBlogs.slice(0, this.state.blogsToDisplay);

        return {
            displayedBlogs,
            filteredBlogs,
            hasMore: displayedBlogs.length < filteredBlogs.length
        };
    }


    render() {
        let blogData = this.readBlogs();
        let existsDestinations = Session.model.blogPages.map(f => f.destination);
        let destinations = this.readDestinations(existsDestinations);

        // <Banner
        //     images={Session.getBannerPictures(Session.model.blog.banner)}
        //     title={Session.model.blog.slogan1}
        //     text={Session.model.blog.slogan2}/>

        return (
            <BasePage data={Session.model.blog}>
                <BreadCrumbs fullpath={window.location.pathname} name={""} /> 
                <i.Container>
                    {/*
                    <i.Row>
                        <i.Col align="left">
                            <div>{i.markdown(Session.model.blog.text)}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row>
                        <i.Col align="left">
                            <div style={{
                                color: "#FF5563",
                                fontSize: 18,
                                paddingTop: 20,
                                fontWeight: "bold"
                            }}>{Session.model.blog.filter}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row align="end">
                        <i.Col xs={12} sm={6} md={3}>
                            <i.DatePicker
                                fullWidth
                                hintText="Controlled Date Input"
                                floatingLabelStyle={floatingLabelStyle}
                                underlineFocusStyle={underlineStyle}
                                underlineStyle={underlineStyle}
                                floatingLabelText={Session.model.common.words.date_from}
                                value={this.state.dateValueFrom}
                                onChange={this.handleDateFromChange}
                            />
                        </i.Col>
                        <i.Col xs={12} sm={6} md={3}>

                            <i.DatePicker
                                fullWidth
                                hintText="Controlled Date Input"
                                floatingLabelStyle={floatingLabelStyle}
                                underlineFocusStyle={underlineStyle}
                                underlineStyle={underlineStyle}
                                floatingLabelText={Session.model.common.words.date_to}
                                value={this.state.dateValueTo}
                                onChange={this.handleDateToChange}
                            />
                        </i.Col>
                        <i.Col xs={12} sm={6} md={3} align='left'>
                            <i.SelectField
                                floatingLabelText={Session.model.destinations.choose_destination}
                                floatingLabelStyle={floatingLabelStyle}
                                fullWidth
                                value={this.state.destination}
                                onChange={this.handleDestinationChange}
                                underlineFocusStyle={underlineStyle}
                                underlineStyle={underlineStyle}
                            >
                                <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={""} />
                                {destinations.map((item, index) => {
                                    return <i.MenuItem key={index} value={item.name} primaryText={item.translations[0].title} />
                                })}
                            </i.SelectField>
                        </i.Col>
                    </i.Row>
                    */}
                    <i.Row style={{marginTop:20, marginBottom:20}}>
                        <i.Col>
                            {/* <h2>{Session.model.blog.title}</h2> */}
                            {Session.model.blogPages.length > 0 ?
                                <c.BlogCardsList
                                    items={blogData.displayedBlogs}
                                    urlBuilder={i.Utils.createBlogUrl}
                                />
                                : <div style={{
                                    color: "#FF5563", fontSize: 18, paddingTop: 20, fontWeight: "bold"
                                }}>{Session.model.common.words.no_result}</div>
                            }
                        </i.Col>
                    </i.Row>
                </i.Container>

            </BasePage >
        );
    }
}

export default Blog;